import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { MailOutlined } from "@ant-design/icons";
import "./VerifyOTP.css";
import Logo from "../../../Components/Logo/Logo";
import axiosInstance from "../../../Config/axiosConfig";

function VerifyOTP({ setLoggedIn, deviceId, userIp }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const email = location.state?.email;

  const handleVerifyOTP = async (values) => {
    setLoading(true);
    const storedDeviceId = deviceId;
    const storedUserIp = userIp;
    try {
      const response = await axiosInstance.post("/User/verify-otp",
        {
          username: email,
          otp: values.otp
        },
        {
          headers: {
            UserDevice: storedDeviceId,
            UserIPAddress: storedUserIp,
          },
        }
      );
      
      if (response.data.code === 200) {
        message.success(response.data.message || "OTP verified successfully");
        navigate("/change-password", { state: { email } });
        const token = response.data.data.jwt;
        localStorage.setItem("verifyToken", token);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      message.error(
        error.response?.data?.message || 
        "Failed to verify OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="verify-otp-page-container">
      <div className="verify-otp-container">
        <Logo />
        <h3>Email Verification(OTP)</h3>
        <span className="verify-otp-text">Enter one-time-pin sent to {email}</span>

        <Form className="verify-otp-form" layout="vertical" onFinish={handleVerifyOTP}>
          <Form.Item
            name="otp"
            rules={[
              { required: true, message: "Please enter OTP" },
              { pattern: /^\d{6}$/, message: "OTP must be 6 digits" }
            ]}
          >
            <Input 
              prefix={<MailOutlined />} 
              placeholder="Enter 6-digit OTP" 
              className="verify-otp-input" 
              maxLength={6}
            />
          </Form.Item>

          <Button 
            type="primary" 
            htmlType="submit" 
            className="verify-otp-button" 
            loading={loading}
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default VerifyOTP;